import { v4 as uuidv4 } from 'uuid';
import { ExampleNodeBuilder } from '../../builder/ExampleNodeBuilder';
import { Type } from '../Type';
export class ExampleList extends Array {
    constructor(values = [], logicalType, tags) {
        super(...values);
        this.type = Type.List;
        this.logicalType = logicalType;
        this.tags = tags;
    }
    static get [Symbol.species]() {
        return Array;
    }
    static new() {
        return new ExampleListBuilder();
    }
}
class ExampleListBuilder {
    constructor() {
        this.items = [];
    }
    addValue(value, build) {
        const builder = ExampleNodeBuilder.newSample(uuidv4(), value);
        if (build)
            build(builder);
        const node = builder.build();
        this.items.push(node);
        return this;
    }
    build() {
        return new ExampleList(this.items);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXhhbXBsZUxpc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL3R5cGVzL2xpc3QvRXhhbXBsZUxpc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEVBQUUsSUFBSSxNQUFNLEVBQUUsTUFBTSxNQUFNLENBQUE7QUFFbkMsT0FBTyxFQUFFLGtCQUFrQixFQUFFLE1BQU0sa0NBQWtDLENBQUE7QUFFckUsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLFNBQVMsQ0FBQTtBQUc5QixNQUFNLE9BQU8sV0FBWSxTQUFRLEtBQWtCO0lBS2pELFlBQ0UsU0FBd0IsRUFBRSxFQUMxQixXQUF5QixFQUN6QixJQUFlO1FBRWYsS0FBSyxDQUFDLEdBQUcsTUFBTSxDQUFDLENBQUE7UUFUVCxTQUFJLEdBQVMsSUFBSSxDQUFDLElBQUksQ0FBQTtRQVU3QixJQUFJLENBQUMsV0FBVyxHQUFHLFdBQVcsQ0FBQTtRQUM5QixJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQTtJQUNsQixDQUFDO0lBRUQsTUFBTSxLQUFLLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQztRQUN6QixPQUFPLEtBQUssQ0FBQTtJQUNkLENBQUM7SUFFRCxNQUFNLENBQUMsR0FBRztRQUNSLE9BQU8sSUFBSSxrQkFBa0IsRUFBRSxDQUFBO0lBQ2pDLENBQUM7Q0FDRjtBQUVELE1BQU0sa0JBQWtCO0lBQXhCO1FBQ1UsVUFBSyxHQUFrQixFQUFFLENBQUE7SUFvQm5DLENBQUM7SUFsQkMsUUFBUSxDQUNOLEtBQW1CLEVBQ25CLEtBQTBDO1FBRTFDLE1BQU0sT0FBTyxHQUFHLGtCQUFrQixDQUFDLFNBQVMsQ0FBQyxNQUFNLEVBQUUsRUFBRSxLQUFLLENBQUMsQ0FBQTtRQUU3RCxJQUFJLEtBQUs7WUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUE7UUFFekIsTUFBTSxJQUFJLEdBQUcsT0FBTyxDQUFDLEtBQUssRUFBRSxDQUFBO1FBRTVCLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFBO1FBRXJCLE9BQU8sSUFBSSxDQUFBO0lBQ2IsQ0FBQztJQUVELEtBQUs7UUFDSCxPQUFPLElBQUksV0FBVyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQTtJQUNwQyxDQUFDO0NBQ0YifQ==